'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ctaButtons = require('./cta-buttons');

var _ctaButtons2 = _interopRequireDefault(_ctaButtons);

var _apiUserImages = require('./api-user-images');

var _apiUserImages2 = _interopRequireDefault(_apiUserImages);

var _embeddedTweets = require('./embedded-tweets');

var _embeddedTweets2 = _interopRequireDefault(_embeddedTweets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO CTA Section',

    render: function render() {
        var props = this.props;
        return _react2['default'].createElement(
            'div',
            { className: 'bg-plume' },
            _react2['default'].createElement(_ctaButtons2['default'], props),
            _react2['default'].createElement(_apiUserImages2['default'], props),
            _react2['default'].createElement(_embeddedTweets2['default'], props)
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/cta-section.jsx
 ** module id = 1212
 ** module chunks = 0
 **/